"use client";
import { Box, Heading, Text } from "@chakra-ui/react";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import { PropsWithChildren } from "react";
export interface PostHeaderProps
  extends PropsWithChildren<{
    title?: string;
    subtitle?: string | MDXRemoteSerializeResult;
  }> {}
export const PostHeader = ({ title, subtitle, children }: PostHeaderProps) => {
  return (
    <Box
      as="header"
      textAlign="center"
      maxW={{ base: "xl", md: "2xl", lg: "5xl" }}
      pt="14"
      mx="auto"
    >
      <Heading
        as="h1"
        size="3xl"
        fontWeight="extrabold"
        letterSpacing="tight"
        lineHeight="1"
        textTransform="capitalize"
      >
        {title}
      </Heading>
      {subtitle && typeof subtitle === "string" ? (
        <Text
          mt="4"
          fontSize={{
            base: "md",
            lg: "lg",
          }}
        >
          {subtitle}
        </Text>
      ) : (
        <Box mt="4">{children}</Box>
      )}
    </Box>
  );
};

export default PostHeader;
